<template>
  <div class="s-chatAutoTranslatePrompt u-marginBottom2">
    <div class="o-flex -alignCenter -spaceBetween -gap3">
      <div class="o-flex -alignCenter -gap2">
        <SvgIcon
          type="info"
          small
          class="u-colorDarkMediumEmphasis o-flex__item -noShrink" />
        <div>
          <div class="t-body3 u-colorDark">{{ $t('chat.auto_translate_prompt.title') }}</div>
          <div class="t-caption1 u-colorDarkMediumEmphasis">{{ $t('chat.auto_translate_prompt.description') }}</div>
        </div>
      </div>
      <div class="o-flex -alignCenter -gap2">
        <button
          class="c-button -success t-noWrap"
          @click="enable">
          {{ $t('chat.auto_translate_prompt.enable') }}
        </button>
        <button
          class="c-button -flat t-noWrap"
          @click="dismiss">
          {{ $t('chat.auto_translate_prompt.not_now') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import api from '@/logic/api'
import chatApi from '@/modules/chat/api/chat'
import { useChatStore } from '@/modules/chat/chatStore'
import { useChatThreadStore } from '@/modules/chat/chatThreadStore'

const chatStore = useChatStore()
const chatThreadStore = useChatThreadStore(chatStore.chatThread.azure_chat_thread_id)

const currentThreadId = computed(() => chatStore.chatThread?.id)
const azureThreadId = computed(() => chatStore.chatThread?.azure_chat_thread_id)

const enable = async () => {
  if (!currentThreadId.value || !azureThreadId.value) {
    return
  }
  try {
    await chatApi.setAutoTranslate(currentThreadId.value, true)
    chatStore.setThreadAutoTranslate(azureThreadId.value, true)
  } catch (e) {
    api.store.commit('notifications/addError', { title: api.i18n.t('chat.auto_translate_prompt.failed_to_enable') })
  } finally {
    chatThreadStore.hideAutoTranslatePrompt()
  }
}

const dismiss = () => {
  if (!currentThreadId.value) {
    return
  }
  chatThreadStore.hideAutoTranslatePrompt()
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/config';
.s-chatAutoTranslatePrompt {
  flex-shrink: 0;
  border-bottom: 1px solid $color-divider;
  background: $color-soft-highlight;
  padding: $spacing-2;
}
</style>
